//deps
import styled from "styled-components";

//tip
export const TipContainer = styled.div({
    display: "flex",
    flexDirection: "column",
    zIndex: 100000,
});

export const ImageBackground = styled.div((props: { backgroundImage: string }) => ({
    backgroundImage: `url(${props.backgroundImage})`,
    height: 72.5,
    margin: "-5px -2px 0 -2px",
    backgroundSize: "cover",
}));

export const TipTitle = styled.div(() => ({
    display: "flex",
    padding: "25px 20px 20px 20px",
    height: 70,
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
}));

export const StyledText = styled.div(({ theme }) => ({
    fontSize: theme.spacing.large,
}));

export const CrossButton = styled.button(() => ({
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 10, // Adjust as needed
}));

export const LableContainer = styled.div(({ theme }) => ({
    marginLeft: theme.spacing.medium,
    marginTop: -12,
    color: theme.colors.light.primary,
    paddingLeft: theme.spacing.xxSmall,
    paddingRight: theme.spacing.xxSmall,
    backgroundColor: theme.colors.light.background_Primary,
    width: "fit-content",
}));

export const InputContainer = styled.div(({ theme }) => ({
    marginBottom: 1,
    padding: theme.spacing.large,
}));

export const TextInputContainer = styled.div(({ theme }) => ({
    marginTop: -theme.spacing.xxSmall,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "16px",
    paddingTop: theme.spacing.xxxSmall,
    paddingBottom: theme.spacing.xSmall,
}));

export const InputWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 12px;
`;

export const CloseCircleIconWrapper = styled.div`
    margin-top: -4px;
`;

export const InputErrorContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
    borderRadius: theme.spacing.small,
    borderWidth: 1.5,
    borderColor: theme.colors.light.primary,
    backgroundColor: theme.colors.light.background_Primary,
    boxShadow: "0px 8px 16px 0px #1B1E241A",
    elevation: 7,
    shadowRadius: 3,
    borderStyle: "solid",
    shadowColor: "rgba(0,0,0,0.4)",
    shadowOpacity: 0.4,
    shadowOffset: { height: 50, width: 0 },
}));

export const StyledInput = styled.input(({ theme }) => ({
    fontSize: theme.spacing.medium,
    fontWeight: 600,
    border: "none",
    marginLeft: 3,
}));

export const ErrorContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
}));

export const ButtonContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.large,
}));
